import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchLeadTimesData from '../Services/fetchLeadTimesData';

export default function useLeadTimesData() {
	const { accessToken } = useAuth();

	const LeadTimesQuery = useQuery({
		queryKey: ['leadTimesData'],
		queryFn: () =>
			fetchLeadTimesData({
				accessToken,
			}),
		staleTime: Infinity,
		retry: false,
		placeholderData: (previousData) => previousData,
	});

	return LeadTimesQuery;
}
